export default "__VITE_ASSET__ix6TZueL__"